<template>
    <v-app>
        <header-component>
            <template v-slot:account_menu>
                <v-menu offset-y transition="slide-y-transition">
                    <template v-slot:activator="{ on, attrs }">
                        <v-toolbar-title style="color:white" v-bind="attrs" v-on="on" class="userName" >
                        {{ user.name }}▼
                        </v-toolbar-title>
                    </template>
                    <v-list>
                        <v-list-item
                        v-for="(item, index) in items"
                        :key="index"
                        link
                        :href="item.href"
                        >
                            <v-list-item-title>
                                <v-icon> {{ item.icon }}</v-icon>
                                {{ item.title }}
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </header-component>
        
        <template>
            <v-app-bar color="#E7F9F7" flat height="60" app style="z-index:99;">
                <v-toolbar-title>
                    <h2>
                        <slot name="title"></slot>
                    </h2>
                </v-toolbar-title>
            </v-app-bar>

            <v-navigation-drawer :permanent="true" :width=275 :app="true" color="#E7F9F7">
                <v-subheader style="height:60px;">
                    <slot name="subheader"></slot>
                </v-subheader>
                
                <!-- メニューをslotで読み込む -->
                <slot name="step_menu"></slot>
                <slot name="optional"></slot>
            </v-navigation-drawer>
        </template>

        <!-- アプリケーションのコンポーネントに基づいてコンテンツのサイズを決定 -->
        <v-main ref="child" class="my-1" :app="true">
            <slot name="contents"></slot>
        </v-main>

        <footer-component>
        </footer-component>
    </v-app>
</template>

<script>
  import {setTimeoutCheckLogin} from '../../common/loginUtil.js';
  export default {
    props: {
        user: Object,
    },
    data: () => ({
        items: [
            { title: 'ダッシュボード', href: '/documents/dashboard', 'icon': 'mdi-home' },
            { title: '管理', href: '/documents/notifications', 'icon': 'mdi-cog' },
            { title: 'ログアウト', href: '/documents/logout', 'icon': 'mdi-logout' },
        ],
    }),
  };
</script>

<style>
    .userName {
      max-width: 70%;
    }
</style>
